export default __webpack_public_path__ + "static/media/logo_square.d50e549e.png";